import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import AdminHeader from "../../component/AdminHeader";
import { ImagePlus, Layers, X } from "lucide-react";
import { FormInput, FormTextArea } from "../../helpers/AdminHelper";
import { http } from "../../axios/axios";
import { Edit, Trash2 } from "lucide-react";
import { GetImageUrl } from "../../helpers/GetImageUrl";
import { useEffect } from "react";
import StatCard from "../../component/StatCard";
import ActionButtons from "../../component/AdminActionButtons";

function CreateIpNetworkBrand({
  handleSubmit,
  closeModal,
  brandDetails,
  setBrandDetails,
  preview,
  setPreview,
}) {
  const inputClass =
    "w-full border border-white/10 bg-white/5 text-white px-4 py-3 rounded-xl mt-2 outline-none focus:border-blue-500 transition";

  const handleChange = (key, value) => {
    setBrandDetails((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    if (preview) {
      URL.revokeObjectURL(preview);
    }

    const url = URL.createObjectURL(file);

    setPreview(url);

    handleChange("brandLogo", file);
  };

  const removeLogo = () => {
    if (preview) {
      URL.revokeObjectURL(preview);
    }

    setPreview(null);

    handleChange("brandLogo", null);
  };

  return (
    <motion.div className="fixed inset-0 bg-black/90 backdrop-blur-xl z-50">
      <motion.div
        className="
        fixed z-50
        top-1/2 left-1/2
        -translate-x-1/2 -translate-y-1/2
        w-[95%] 
        h-[90vh]
        bg-[#0a0f1a]
        border border-white/10
        rounded-2xl
        shadow-2xl
        overflow-hidden
        flex flex-col
        "
      >
        <div
          className="
          flex items-center justify-between
          px-8 py-5
          border-b border-white/10
          bg-white/[0.03]
          "
        >
          <div>
            <h3 className="text-xl font-black text-white uppercase">
              Create IT Product Brand
            </h3>

            <p className="text-sm text-slate-400 mt-1">
              Add brand details and logo
            </p>
          </div>

          <button
            type="button"
            onClick={closeModal}
            className="
            h-10 w-10
            rounded-xl
            bg-white/5
            hover:bg-red-500
            text-slate-300
            flex items-center
            justify-center
            "
          >
            <X size={20} />
          </button>
        </div>

        <form
          onSubmit={handleSubmit}
          className="
          p-8
          space-y-5
          overflow-y-auto
          flex-1
          "
        >
          <div>
            <label className="text-sm text-slate-300">Brand Logo</label>

            {preview ? (
              <div
                className="
                mt-2
                relative
                h-36
                rounded-xl
                border border-white/10
                bg-white/5
                flex items-center justify-center
                overflow-hidden
                "
              >
                <img
                  src={preview}
                  alt="brand preview"
                  className="
                  h-full
                  w-full
                  object-contain
                  "
                />

                <button
                  type="button"
                  onClick={removeLogo}
                  className="
                  absolute
                  top-2
                  right-2
                  h-8
                  w-8
                  rounded-full
                  bg-red-500
                  text-white
                  flex
                  items-center
                  justify-center
                  "
                >
                  <X size={16} />
                </button>
              </div>
            ) : (
              <label
                className="
                mt-2
                h-36
                rounded-xl
                border border-dashed border-white/20
                bg-white/5
                flex flex-col
                items-center
                justify-center
                cursor-pointer
                hover:bg-white/10
                transition
                "
              >
                <ImagePlus size={30} className="text-slate-400" />

                <span className="text-sm text-slate-400 mt-2">Upload logo</span>

                <input
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={handleLogoChange}
                />
              </label>
            )}
          </div>

          <div>
            <FormInput
              label={"Brand Name"}
              className={inputClass}
              placeholder={"Cisco"}
              value={brandDetails?.brandName}
              onChange={(e) => handleChange("brandName", e.target.value)}
            />
          </div>

          <div>
            <FormInput
              label={"Website"}
              className={inputClass}
              placeholder={"https://cisco.com"}
              value={brandDetails.brandWebsite}
              onChange={(e) => handleChange("brandWebsite", e.target.value)}
            />
          </div>

          <div>
            <FormInput
              label={"Contact Support"}
              className={inputClass}
              placeholder="+91 XXXXX XXXXX ( Optional )"
              value={brandDetails?.brandContact}
              onChange={(e) => handleChange("brandContact", e.target.value)}
            />
          </div>

          <div>
            <FormTextArea
              label={"Description"}
              rows={4}
              placeholder="Write a short 2–3 line description about the brand for display on the frontend."
              value={brandDetails.description}
              onChange={(e) => handleChange("description", e.target.value)}
            />
          </div>

          <div>
            <FormInput
              label={"Meta Title"}
              className={inputClass}
              value={brandDetails.metaTitle}
              onChange={(e) => handleChange("metaTitle", e.target.value)}
              placeholder="Cisco Networking Products"
            />
          </div>

          <div>
            <FormTextArea
              label={"Meta Description"}
              rows={4}
              placeholder={"Buy Cisco routers, switches and networking products..."}
              value={brandDetails.metaDescription}
              onChange={(e) => handleChange("metaDescription", e.target.value)}
            />
          </div>

          <div>
            <FormInput
              label={"Keywords"}
              className={inputClass}
              placeholder="router, switch, cisco, networking"
              value={brandDetails.keywords}
              onChange={(e) => handleChange("keywords", e.target.value)}
              helperText={"Separate keywords with commas"}
            />
          </div>
          <div>
            <FormInput
              label={"Slug"}
              className={inputClass}
              placeholder={"cisco"}
              value={brandDetails.slug}
              onChange={(e) => handleChange("slug", e.target.value)}
              helperText={"Used in URL: /it-products/brand/cisco"}
            />
          </div>
          <div>
            <FormTextArea
              label={"Schema Script (JSON-LD)"}
              rows={8}
              placeholder={`{
  "@context": "https://schema.org",
  "@type": "Brand",
  "name": "Cisco"
}`}
              value={brandDetails.schemaScript || ""}
              onChange={(e) => handleChange("schemaScript", e.target.value)}
            />

            <p className="text-xs text-slate-400 mt-2">
              Add valid JSON-LD schema only
            </p>
          </div>

          <div
            className="
            flex justify-end
            pt-5
            border-t border-white/10
            "
          >
            <button
              type="submit"
              className="
              w-full
              px-8 py-3
              rounded-xl
              bg-blue-600
              hover:bg-blue-500
              text-white
              font-bold
              "
            >
              Save Brand
            </button>
          </div>
        </form>
      </motion.div>
    </motion.div>
  );
}

const AdminIpNetworkBrands = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [brandDetails, setBrandDetails] = useState({
    brandName: "",
    brandWebsite: "",
    brandContact: "",
    brandLogo: null,
    slug: "",
    description: "",
    metaTitle: "",
    metaDescription: "",
    keywords: "",
    schemaScript: "",
  });
  const [preview, setPreview] = useState(null);
  const [totalBrandCount, setTotalBrandCount] = useState(null);
  const [brands, setBrands] = useState([]);
  const [editId, setEditId] = useState(null);
  const [pagination, setPagination] = useState({
    page: 1,
    totalPages: 1,
    limit: 20,
  });

  const resetForm = () => {
    setBrandDetails({
      brandName: "",
      slug: "",
      brandWebsite: "",
      brandContact: "",
      brandLogo: null,

      description: "",
      metaTitle: "",
      metaDescription: "",
      keywords: "",
      schemaScript: "",
    });
    if (preview) {
      URL.revokeObjectURL(preview);
    }
    setPreview(null);
  };

  const closeModal = () => {
    resetForm();
    setEditId(null);
    setIsModalOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const {
      brandName,
      brandWebsite,
      brandContact,
      description,
      metaTitle,
      metaDescription,
      slug,
      keywords,
    } = brandDetails;

    if (!brandName?.trim()) return alert("Brand name is required");
    if (!description?.trim()) return alert("Description is required");
    if (!metaTitle?.trim()) return alert("Meta title is required");
    if (!metaDescription?.trim()) return alert("Meta description is required");
    if (!slug?.trim()) return alert("Slug is required");

    const formData = new FormData();

    formData.append("brandName", brandName);
    formData.append("brandWebsite", brandWebsite || "");
    formData.append("brandContact", brandContact || "");
    formData.append("description", description);
    formData.append("metaTitle", metaTitle);
    formData.append("metaDescription", metaDescription);
    formData.append("slug", slug);
    const keywordArray = Array.isArray(keywords)
      ? keywords
      : keywords
          ?.split(",")
          .map((k) => k.trim())
          .filter(Boolean);

    formData.append("keywords", JSON.stringify(keywordArray));
    let schemaData = "";

    if (brandDetails.schemaScript?.trim()) {
      try {
        JSON.parse(brandDetails.schemaScript);
        schemaData = brandDetails.schemaScript;
      } catch {
        return alert("Invalid Schema JSON");
      }
    }
    formData.append("schemaScript", schemaData);
    if (brandDetails.brandLogo) {
      formData.append("brandLogo", brandDetails.brandLogo);
    }
    try {
      if (editId) {
        await http.put(`/ip-network/brands/update/${editId}`, formData);
      } else {
        await http.post("/ip-network/brands", formData);
      }

      await getBrands();
      closeModal();
      setEditId(null);
    } catch (error) {
      console.log(error.response?.data || error.message);
    }
  };

  const getBrands = async () => {
    try {
      const res = await http.get("/ip-network/brands", {
        params: {
          page: pagination.page,
          limit: pagination.limit,
        },
      });

      setBrands(res.data.brands);
      setTotalBrandCount(res.data.total);

      setPagination((prev) => ({
        ...prev,
        page: res.data.page,
        totalPages: res.data.totalPages,
      }));
    } catch (error) {
      console.log(error.response?.data || error.message);
    }
  };

  useEffect(() => {
    getBrands();
  }, [pagination.page]);

  return (
    <div className="p-4 md:p-8 min-h-screen text-slate-200">
      <AdminHeader
        title="IT Product Brands"
        buttonText="Add Brand"
        onClick={() => setIsModalOpen(true)}
      />
      <div className="mb-8  gap-4">
        <StatCard title="Total IT Product Brands" count={totalBrandCount} icon={Layers} />
      </div>
      <div className="space-y-4">
        {brands.length === 0 ? (
          <div
            className="
    p-8
    rounded-2xl
    bg-white/5
    border border-white/10
    text-center
    text-slate-400
  "
          >
            No brands found
          </div>
        ) : (
          brands.map((brand) => (
            <div
              key={brand._id}
              className="
      flex
      flex-col sm:flex-row
      sm:items-center
      sm:justify-between
      gap-4
      p-2
      rounded
        bg-slate-900/40
        border border-slate-800
        hover:border-slate-700
        hover:bg-slate-900/60
      transition
    "
            >
              {/* Left Content */}
              <div className="flex items-center gap-3 sm:gap-4">
                <div
                  className="
          h-12 w-12
          sm:h-16 sm:w-16
          rounded
          bg-white
          p-2
          flex
          items-center
          justify-center
          shrink-0
        "
                >
                  <img
                    src={GetImageUrl(brand.brandLogo)}
                    className="
            max-h-full
            max-w-full
            object-contain
          "
                  />
                </div>

                <div>
                  <h3
                    className="
            text-white
            font-bold
            text-sm lg:text-base
          "
                  >
                    {brand.brandName}
                  </h3>

                  <p
                    className="
            text-slate-400
            text-xs
            sm:text-sm
          "
                  >
                    {brand.slug}
                  </p>
                </div>
              </div>
              {/* Actions */}
              <ActionButtons
                onEdit={() => {
                  setEditId(brand._id);

                  setBrandDetails({
                    ...brand,
                    brandLogo: null,
                    keywords: Array.isArray(brand.keywords)
                      ? brand.keywords.join(", ")
                      : brand.keywords || "",
                  });

                  setPreview(
                    brand.brandLogo ? GetImageUrl(brand.brandLogo) : null,
                  );

                  setIsModalOpen(true);
                }}
                onDelete={async () => {
                  if (!confirm("Delete this brand?")) return;

                  await http.delete(`/ip-network/brands/delete/${brand._id}`);

                  getBrands();
                }}
              />{" "}
            </div>
          ))
        )}
      </div>
      {brands.length > 0 && (
        <div
          className="
      flex
      flex-col sm:flex-row
      justify-center
      items-center
      gap-3 sm:gap-4
      mt-8
      px-2
    "
        >
          <button
            disabled={pagination.page === 1}
            onClick={() =>
              setPagination((prev) => ({
                ...prev,
                page: prev.page - 1,
              }))
            }
            className="
        w-full sm:w-auto
        px-4 sm:px-5
        py-2
        rounded-xl
        bg-white/10
        hover:bg-white/20
        disabled:opacity-40
        transition
        text-sm sm:text-base
      "
          >
            Previous
          </button>

          <span
            className="
        text-white
        text-sm sm:text-base
        whitespace-nowrap
      "
          >
            Page {pagination.page} of {pagination.totalPages}
          </span>

          <button
            disabled={pagination.page === pagination.totalPages}
            onClick={() =>
              setPagination((prev) => ({
                ...prev,
                page: prev.page + 1,
              }))
            }
            className="
        w-full sm:w-auto
        px-4 sm:px-5
        py-2
        rounded-xl
        bg-blue-600
        hover:bg-blue-700
        disabled:opacity-40
        transition
        text-sm sm:text-base
      "
          >
            Next
          </button>
        </div>
      )}

      <AnimatePresence>
        {isModalOpen && (
          <CreateIpNetworkBrand
            handleSubmit={handleSubmit}
            closeModal={closeModal}
            setBrandDetails={setBrandDetails}
            brandDetails={brandDetails}
            preview={preview}
            setPreview={setPreview}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default AdminIpNetworkBrands;
